define('views/blocks/FreeProductChoiceVoucherView',['jquery', 'underscore', 'backbone',
        'app', 'SubView',
        'views/pages/ProductPageView',
        'template!blocks/cart/free-product-choice-voucher'
    ],
    function ($, _, Backbone,
              app,
              SubView,
              ProductPageView,
              FreeProductVoucherTemplate
    ) {

    //
    //

    var id_product_initial,
        voucher;

    return Backbone.View.extend(SubView).extend({

        events: {
            'click .btn-close': 'clickClose',
            'click .cat-link': 'displayCategory',
            'change .product-choice': 'selectProduct',
            'submit form':'submit'
        },

        initialize: function (options) {
            var view = this;
            view.render(options);
        },

        render: function (options) {

            var view = this,
                cart = app.getCart();

            voucher = options.voucher;
            id_product_initial = cart.getProductOfferedId() || 0;

            var categories_checked = [];
            cart.getCategoriesOffered().forEach(function (id) {
                var category = app.getCategory(id);
                if (!_.isUndefined(category)) {
                    categories_checked.push(id)
                }
            });

            var id_category = 0,
                categories = _(_(categories_checked).map(function(id){
                    var category = app.getCategory(id);
                    if (category) {
                        if (category.containsId(id_product_initial + '') || !id_category) {
                            id_category = id;
                        }
                    }
                    return category;
                }));


            var t = FreeProductVoucherTemplate({
                id_category:id_category,
                id_product:id_product_initial,
                voucher: voucher,
                categories:categories
            });
            //
            view.$el.html(t);
            view.delegateEvents();
            //
        },

        displayCategory:function(e){
            var view = this,
                groups = view.$('.free-product-choice-voucher__products-group, .cat-link-li'),
                id_category = $(e.currentTarget).parent().data('id');
            groups.removeClass('active');
            groups.filter('[data-id="'+id_category+'"]').addClass('active');
            view.$('input.product-choice').prop('checked',false);
            view.toggleSubmitDisabled(true);
        },

        toggleSubmitDisabled:function(disabled,loading){
            this.$('.submit')
                .attr('disabled',disabled)
                .toggleClass('loading',loading===true);
        },

        getSelectedProductId:function(){
            return this.$('input.product-choice:checked').val();
        },

        selectProduct:function(){
            this.toggleSubmitDisabled(false);
        },

        submit:function(e){
            e.preventDefault();
            var view = this,
                cart = app.getCart(),
                id_product_selected = view.getSelectedProductId(),
                product = app.getProduct(id_product_selected);
            if(product){
                if(id_product_initial == id_product_selected){
                    // si on a pas changé de produit
                    view.close();
                }

                if(product.isMenu()){
                    var menuProductModalView = new ProductPageView({
                        id_product:id_product_selected,
                        voucher_free_product:true
                    });
                    function close(){
                        completeModal(false);
                    }
                    function complete(){
                        menuProductModalView.close();
                        app.trigger('addVoucher');
                        view.close();
                    }
                    function completeModal(sidedishesSelected){
                        view.stopListening(menuProductModalView,'selectFreeProductSidedishes');
                        view.stopListening(menuProductModalView,'close');
                        if(sidedishesSelected){
                            view.listenTo(app,'setProductLikeOffered',complete);
                            cart.setProductLikeOffered(id_product_selected,sidedishesSelected);
                        }
                    }
                    view.listenToOnce(menuProductModalView,'selectFreeProductSidedishes',completeModal);
                    view.listenToOnce(menuProductModalView,'close',close);
                    app.displayModal(menuProductModalView);
                    return;
                }

                view.toggleSubmitDisabled(true,true);
                view.listenTo(app,'setProductLikeOffered',view.setProductLikeOffered);
                cart.setProductLikeOffered(id_product_selected);
            }else{
                app.alert(app.t('Vous devez sélectionner un produit','Product'));
            }
        },

        setProductLikeOffered:function(){
            app.trigger('addVoucher');
            this.close();
        },

        close:function(){
            var view = this;
            view.trigger('close', view);
        },

        clickClose: function () {
            var view = this,
                cart = app.getCart();
            function canceled() {
                app.trigger('cancelVoucher');
                view.close();
            }
            if(!id_product_initial){
                //
                // si on a pas de selection, et pas de produit déjà affecté
                // on annule le coupon
                view.$('.main-content').html('<div class="loader"></div>');
                cart.removeVoucher(voucher.id_cart_discount).done(canceled)
            }else{
                app.trigger('addVoucher');
                view.close();
            }
        },


    });
});
